import { Injectable, Injector, inject } from '@angular/core';
import { TuiDialogService, TuiDialogSize } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';

import { ChatCreateFormComponent } from '../chat-create-form.component';
import { ContentDataType } from '../types';

@Injectable({
  providedIn: 'root',
})
export class CreateDialogService {
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  open(label: string, data?: ContentDataType, size: TuiDialogSize = 's', closeable = false, dismissible = false) {
    return this.dialogService.open<string | undefined>(
      new PolymorpheusComponent(ChatCreateFormComponent, this.injector),
      {
        label,
        data,
        size,
        closeable,
        dismissible,
      },
    );
  }
}
